import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

export const NftCardPlaceholderWrapper = styled(motion.div)`
    width: 100%;
`;

export const NftCardPlaceholderAsset = styled(motion.div)`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    aspect-ratio: 1 / 1;
    width: 100%;
    margin-bottom: 11px;
    background: radial-gradient(
            70.94% 70.94% at 36.73% 29.06%,
            rgba(255, 255, 255, 0.05) 0%,
            rgba(255, 255, 255, 0) 100%
        )
        rgba(255, 255, 255, 0.06);

    svg {
        fill: white;
    }
`;

export const NftCardPlaceholderText = styled(motion.div)<{ $height: number }>`
    width: 100%;
    margin-bottom: 10px;
    border-radius: 5px;
    background: radial-gradient(
            70.94% 70.94% at 36.73% 29.06%,
            rgba(255, 255, 255, 0.05) 0%,
            rgba(255, 255, 255, 0) 100%
        )
        rgba(255, 255, 255, 0.06);

    ${({ $height }) => css`
        height: ${$height}px;
    `}
`;
